const SELECTOR = [
  '.team-section',
  '[data-medical-team-section] .section-content-wrapper > .group-block',
  '[id*="section_AYrAcM"] .section-content-wrapper > .group-block',
].join(', ');

function initMedicalTeamCarousel(team) {
  if (!team || team.dataset.medicalTeamCarouselReady === 'true') return;

  const track = Array.from(team.children).find((child) => child.classList.contains('group-block-content'));
  const cards = track
    ? Array.from(track.children).filter(
        (child) =>
          child.classList.contains('group-block') &&
          child.querySelector('.image-block, img') &&
          child.querySelector('.text-block')
      )
    : [];

  if (!track || cards.length < 3) return;

  const section = team.closest('.section');
  section?.classList.add('medical-team-section');
  team.classList.add('medical-team-carousel');
  team.dataset.medicalTeamCarouselReady = 'true';

  cards.forEach((card) => {
    card.classList.add('medical-team-card');
    card.setAttribute('data-medical-team-card', '');
    card.querySelectorAll('img').forEach((image) => {
      image.draggable = false;
    });
  });

  let activeIndex = Math.min(1, cards.length - 1);
  let startX = 0;
  let dragDelta = 0;
  let isDragging = false;
  let movedDuringGesture = false;
  let activePointerId = null;
  const dragThreshold = 160;
  const dragVisualRatio = 0.36;
  const maxDragPreview = 64;

  const applyActiveState = () => {
    cards.forEach((card, index) => {
      const relative = (index - activeIndex + cards.length) % cards.length;
      card.classList.toggle('is-medical-center', relative === 0);
      card.classList.toggle('is-medical-active', relative === 0);
      card.classList.toggle('is-medical-right', relative === 1);
      card.classList.toggle('is-medical-left', relative === cards.length - 1);
    });
  };

  const centerActiveCard = () => {
    const activeCard = cards[activeIndex];
    if (!activeCard) return;

    const activeCenter = activeCard.offsetLeft + activeCard.offsetWidth / 2;
    const offset = team.clientWidth / 2 - activeCenter;
    track.style.setProperty('--medical-team-offset-x', `${offset}px`);
  };

  const render = () => {
    applyActiveState();
    track.style.setProperty('--medical-team-drag-x', '0px');
    centerActiveCard();
    window.requestAnimationFrame(centerActiveCard);
    window.setTimeout(centerActiveCard, 260);
  };

  const goTo = (index) => {
    activeIndex = (index + cards.length) % cards.length;
    render();
  };

  const startDrag = (event) => {
    if (event.button !== undefined && event.button !== 0) return;

    startX = event.clientX;
    dragDelta = 0;
    isDragging = true;
    movedDuringGesture = false;
    activePointerId = event.pointerId ?? null;
    team.classList.add('is-dragging');

    try {
      team.setPointerCapture?.(event.pointerId);
    } catch (_error) {}

    event.preventDefault();
  };

  const moveDrag = (event) => {
    if (!isDragging) return;
    if (activePointerId !== null && event.pointerId !== activePointerId) return;

    event.preventDefault();
    dragDelta = event.clientX - startX;
    movedDuringGesture = movedDuringGesture || Math.abs(dragDelta) > 8;
    const previewDelta = Math.max(
      -maxDragPreview,
      Math.min(maxDragPreview, dragDelta * dragVisualRatio)
    );
    track.style.setProperty(
      '--medical-team-drag-x',
      `${previewDelta}px`
    );

    if (Math.abs(dragDelta) >= dragThreshold) {
      activeIndex = (activeIndex + (dragDelta < 0 ? 1 : -1) + cards.length) % cards.length;
      startX = event.clientX;
      dragDelta = 0;
      render();
    }
  };

  const endDrag = (event) => {
    if (!isDragging) return;
    if (activePointerId !== null && event.pointerId !== activePointerId) return;

    isDragging = false;
    activePointerId = null;
    team.classList.remove('is-dragging');
    track.style.setProperty('--medical-team-drag-x', '0px');

    if (Math.abs(dragDelta) >= dragThreshold) {
      goTo(activeIndex + (dragDelta < 0 ? 1 : -1));
    } else {
      render();
    }
  };

  cards.forEach((card, index) => {
    card.addEventListener('click', () => {
      if (!movedDuringGesture) goTo(index);
    });
  });

  team.addEventListener('pointerdown', startDrag, { passive: false });
  window.addEventListener('pointermove', moveDrag, { passive: false });
  window.addEventListener('pointerup', endDrag, { passive: true });
  window.addEventListener('pointercancel', endDrag, { passive: true });
  window.addEventListener('resize', render, { passive: true });

  render();
}

function initAllMedicalTeamCarousels(root = document) {
  root.querySelectorAll?.(SELECTOR).forEach(initMedicalTeamCarousel);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllMedicalTeamCarousels(), { once: true });
} else {
  initAllMedicalTeamCarousels();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllMedicalTeamCarousels(event.target);
});

document.addEventListener('shopify:block:select', (event) => {
  const team = event.target?.closest?.(SELECTOR);
  if (team) initMedicalTeamCarousel(team);
});
